import { assignOverlapTracks as sharedAssignOverlapTracks, type TrackAssignment } from '@da-g3-acl/shared/common';

import { IntervalLaneRowInterval } from '../configurations';

export type { TrackAssignment };

type DepthRange = { depthFrom: number; depthTo: number };

export function assignOverlapTracks(
	intervals: IntervalLaneRowInterval[],
	getDepthRange: (interval: IntervalLaneRowInterval) => DepthRange,
	getLabel?: (interval: IntervalLaneRowInterval) => string | undefined,
): Map<IntervalLaneRowInterval, TrackAssignment> {
	return sharedAssignOverlapTracks(intervals, getDepthRange, getLabel);
}
